/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fluffy_Long_Porpoise_TransformInputs */

const fr_fluffy_long_porpoise_transform = /** @type {(inputs: Fluffy_Long_Porpoise_TransformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion`)
};

/**

* @param {Fluffy_Long_Porpoise_TransformInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fluffy_long_porpoise_transform = /** @type {((inputs?: Fluffy_Long_Porpoise_TransformInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fluffy_Long_Porpoise_TransformInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fluffy_long_porpoise_transform(inputs)
});